"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = exports.ModalListItem = exports.ModalList = exports.StyledModalBody = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.StyledModalBody = styled_components_1.default.div `
  width: ${(0, wl_ui_kit_1.getSizeBy)(96)};
  max-width: 100%;
  padding: ${(0, wl_ui_kit_1.getSizeBy)(6)};
`;
exports.ModalList = (0, styled_components_1.default)(wl_ui_kit_1.List) `
  margin: ${(0, wl_ui_kit_1.getSizeBy)(2)} 0;
  ${wl_ui_kit_1.Body2Styles}
`;
exports.ModalListItem = (0, styled_components_1.default)(wl_ui_kit_1.ListItem) `
  & > div {
    padding-left: 0;
  }
`;
exports.Email = styled_components_1.default.a `
  text-decoration: none;
`;
